import React from 'react';
import { Box, Card, CardContent, Typography, Button } from '@mui/material';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import LockIcon from '@mui/icons-material/Lock';
import { useNavigate } from 'react-router-dom';
import { capabilityDetails, useCapabilityAccess } from '../capabilities';

const TIER_LABEL = { pro: 'Pro', team: 'Team' };

/** 包住真实功能 UI: children 正常渲染(demo 数据), 上面叠半透明灰遮罩 + 居中订阅 CTA。
 *  locked=false 时直接渲染 children(订阅用户无遮罩)。 */
export default function LockedOverlay({ capability, tier = 'team', locked, label, children }) {
  const navigate = useNavigate();
  const { matrix, allowed } = useCapabilityAccess(capability);
  const resolvedLocked = typeof locked === 'boolean' ? locked : !allowed;
  if (!resolvedLocked) return <>{children}</>;
  const spec = capabilityDetails(matrix, capability);
  const requiredTier = spec?.minimum_tier || tier;
  const t = TIER_LABEL[requiredTier] || requiredTier?.toUpperCase() || 'Team';
  const capabilityLabel = spec?.label;
  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ filter: 'grayscale(0.6) blur(1px)', opacity: 0.5, pointerEvents: 'none', userSelect: 'none' }}>
        {children}
      </Box>
      <Box sx={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center',
                 justifyContent: 'center', bgcolor: 'rgba(15,15,25,0.35)', borderRadius: 1 }}>
        <Card sx={{ border: '1px dashed #fbbf24aa', bgcolor: 'rgba(20,20,30,0.95)', maxWidth: 360 }}>
          <CardContent sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'center' }}>
            <LockIcon sx={{ color: '#fbbf24', fontSize: 32 }} />
            <Typography variant="body1" fontWeight={700}>{label || capabilityLabel || `${t} 专属功能`}</Typography>
            <Typography variant="caption" color="text.secondary">
              这是 {t} 版功能的真实界面(示例数据)。订阅 {t} 解锁你自己的真实数据与操作。
            </Typography>
            <Button size="small" variant="contained" color="warning"
                    startIcon={<WorkspacePremiumIcon />} onClick={() => navigate('/pricing')}>
              订阅 {t} 解锁
            </Button>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
